@import "config";

.container {
	@include vstack($spacing-stack-quarck);

	.headerContainer {
		@include hstack($spacing-stack-nano);

		.label {
			@include flex(row, unset, center);
			height: $spacing-stack-xxs;
			font-size: $font-size-xxs;
			font-weight: $font-weight-bold;
			color: $color-dark-d1;

			.required {
				font-size: $font-size-xs;
				color: $color-error-medium;
			}
		}
	}

	.validate {
		text-transform: uppercase;
		// os tokens mais próximos ficam muito grandes ou muito pequenos
		font-size: $font-size-xxxs;
	}

	.warning {
		@extend .validate;

		color: $color-warning-medium;
	}

	.error {
		@extend .validate;

		color: $color-error-medium;
	}

	.help {
		@extend .validate;
		color: $color-dark-d1;
	}

	.description {
		font-size: $font-size-xxs;
		color: $color-dark-d2;
	}
}
